// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vueperslide[data-v-4a6c3d93],.vueperslide--active[data-v-4a6c3d93],.vueperslide--visible[data-v-4a6c3d93]{background-size:contain!important;background-repeat:no-repeat!important;background-position:50%!important;background:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
